import styled from "styled-components"

export const Wrapper = styled.section`
  padding: 40px 0;
`
